import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { rootRoute } from './root'

const AffiliateSms = lazyRouteComponent(() => import('../pages/affiliate-sms'))

export const affiliateSmsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/sms/$affiliate',
  component: AffiliateSms,
})
